import React, { useState } from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import { FormattedMessage } from '../../util/reactIntl';
import { ensureOwnListing } from '../../util/data';
import { findOptionsForSelectFilter } from '../../util/search';
import { ListingLink} from '../../components';
import { EditListingCancelLimitForm } from '../../forms';
import config from '../../config.js';

// Create this file using EditListingDescriptionPanel.module.css
// as a template.
import css from './EditListingCancelLimitPanel.module.css';

const EditListingCancelLimitPanel = props => {
  const {
    className,
    rootClassName,
    listing,
    onSubmit,
    onChange,
    submitButtonText,
    panelUpdated,
    updateInProgress,
    errors,
  } = props;
  const classes = classNames(rootClassName || css.root, className);
  const currentListing = ensureOwnListing(listing);
  const { publicData } = currentListing.attributes;
  // const [hasCancellationPolicy, setHasCancellationPolicy] = useState(listing.attributes.publicData.cancelLimit && listing.attributes.publicData.cancelLimit !== "365")
  // const [hasCancellationPolicyOneDay, setHasCancellationPolicyOneDay] = useState(listing.attributes.publicData.cancelLimit && listing.attributes.publicData.cancelLimit !== "1")
   console.log(publicData)
//   const handleCancellationPolicy = ({target}) => {
//     setHasCancellationPolicyOneDay(false)
//     if (target.checked){
//        console.log("checked")
//        setHasCancellationPolicy(false)
//     } else {
//        console.log("not checked")
//        setHasCancellationPolicy(true)
//     }
// }

// const handleCancellationPolicyOneDay = ({target}) => {
//   setHasCancellationPolicy(false)
//   if (target.checked){
//     console.log("checked")
//     setHasCancellationPolicyOneDay(false)
//  } else {
//     console.log("not checked")
//     setHasCancellationPolicyOneDay(true)
//  }
// }

  const handleSubmit = (values) => {
//     const noCancellationLimitObj = {
//           id: listing.id,
//           publicData: {
//             cancelLimit: "365"
//           }
//     }

//     const oneDayCancellationLimitObj = {
//       id: listing.id,
//       publicData: {
//         cancelLimit: "1"
//       }
// }

    const { cancelLimit } = values;

          const updateValues = {
            publicData: {
              cancelLimit: cancelLimit,
            },
          };
          onSubmit(updateValues);
  }
  const panelTitle = currentListing.id ? (
    <FormattedMessage
      id="EditListingCancelLimitPanel.title"
      values={{ listingTitle: <ListingLink listing={listing} /> }}
    />
  ) : (
    <FormattedMessage id="EditListingCancelLimitPanel.createListingTitle" />
  );
  const cancelLimitOptions = findOptionsForSelectFilter(
    'cancelLimit',
    config.custom.filters
  );

  return (
    <div className={classes}>
      <h1 className={css.title}>{panelTitle}</h1>
      <EditListingCancelLimitForm
        // hasCancellationPolicy={hasCancellationPolicy}
        cancelLimitIsZero={listing.attributes.publicData.cancelLimit === "365"}
        cancelLimitIsOneDay={listing.attributes.publicData.cancelLimit === "1"}
        // handleCancellationPolicy={handleCancellationPolicy}
        // handleCancellationPolicyOneDay={handleCancellationPolicyOneDay}
        className={css.form}
        initialValues={{ cancelLimit: publicData.cancelLimit }}
        onSubmit={handleSubmit}
        onChange={onChange}
        saveActionMsg={submitButtonText}
        updated={panelUpdated}
        updateError={errors.updateListingError}
        updateInProgress={updateInProgress}
        cancelLimitOptions={cancelLimitOptions}
      />
    </div>
  );
};

const { func, object, string, bool } = PropTypes;

EditListingCancelLimitPanel.defaultProps = {
  className: null,
  rootClassName: null,
  listing: null,
};

EditListingCancelLimitPanel.propTypes = {
  className: string,
  rootClassName: string,

  // We cannot use propTypes.listing since the listing might be a draft.
  listing: object,

  onSubmit: func.isRequired,
  onChange: func.isRequired,
  submitButtonText: string.isRequired,
  panelUpdated: bool.isRequired,
  updateInProgress: bool.isRequired,
  errors: object.isRequired,
};

export default EditListingCancelLimitPanel;